const state = {
  currentApplicationId: null,
  applications: {
    byId: {},
    allIds: []
  },
  schema: {
    byId: {},
    allIds: []
  },
  disclaimers: [],
  applicationSourceType: {
    byId: {},
    allIds: []
  },
  applicationsMetadata: {
    byId: {},
    allIds: []
  },
  acceptedConsents: [],
  guestFillOutDetails: {
    token: "",
    clientDetails: {}
  },
  isFillOut: false,
  consolidatedRequest: {},
  additionalInformation: "",
  loading: true,
  currentApplicationChanges: {},
  flow: "",
  currentComputedSchema: {}
};
export default state;